export default [{
    path: '/',
    name: 'home',
    component: () => import('@/pages/v2/home'),
},
// {
//     path: '/front/index',
//     name: 'home',
//     component: () => import('@/pages/index/index3'),
//     meta: meta
// }
];



// WEBPACK FOOTER //
// ./src/router/home.js